module.exports = __webpack_public_path__ + "img/5be0d5767c843c53ae3b3ab5bc2ff06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo8.png
// module id = 916
// module chunks = 5